<template>
<div>
    <div class="pc warp">
        <!--侧边导航-->
        <div class="nav-list" v-if="showNavPc">
            <ul class="nav-line">
                <li class="nav-line-item" @click="goPath('/home', '首页')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/home'==currentHash }"><p>首页</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavAgendaDesc" @click="goPath('/desc', '大会介绍')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/desc'==currentHash }"><p>大会介绍</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavAgendaList" @click="goPath('/agenda', '大会议程')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/agenda'==currentHash }"><p>大会议程</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavGuest" @click="goPath('/guest', '重磅嘉宾')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/guest'==currentHash }"><p>重磅嘉宾</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavHall" @click="goPath('/exhibition', '展厅导览')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/exhibition'==currentHash }"><p>展厅导览</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavNews" @click="goPath('/news', '热门资讯')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/news'==currentHash }"><p>热门资讯</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavPartner" @click="goPath('/partner', '生态伙伴')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/partner'==currentHash }"><p>生态伙伴</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavPic" @click="goPath('/wonderfulPic', '精彩图集')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/wonderfulPic'==currentHash }"><p>精彩图集</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavWords" @click="goPath('/wonderfulWords', '大咖观点')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/wonderfulWords'==currentHash }"><p>大咖观点</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavVideo" @click="goPath('/video', '精彩视频')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/video'==currentHash }"><p>精彩视频</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" v-if="showNavDownload" @click="goPath('/files', '资料中心')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/files'==currentHash }"><p>资料中心</p><div class="line"></div></div>
                </li>
                <li class="nav-line-item" @click="goPath('/guide', '参会指南')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/guide'==currentHash }"><p>参会指南</p><div class="line"></div></div>
                </li>
            </ul>
        </div>
        <div class="fixed-div">
            <div class="logo"><img src="../assets/newImages/home/logo.png" alt=""></div>
            <div class="header-right">
                <div v-if="userLogin" @click="goPath('/my', '个人中心')" class="people"><img src="../assets/newImages/home/people.png" alt=""></div>
                <div class="right flexCenter" @click="goHuaweiHome()"><img src="../assets/newImages/home/header2.png" alt=""><p>进入华为官网</p></div>
            </div>
            <!-- <div class="header-right2 flexCenter" @click="goHuaweiHome()"><img src="../assets/newImages/home/header2.png" alt=""><p>进入华为官网</p></div> -->
        </div>
    </div>
    <div class="wap">
        <div class="logo position-absolute" v-if="!showWapNavIcon">
            <img src="../assets/newImages/common/navWap/logo.png" alt="">
        </div>
        <!-- 隐私政策tab -->
        <div class="header-right" v-if="!showWapNavIcon">
            <div class="people" style="display:none;"><img src="../assets/newImages/home/people.png" alt=""></div>
            <div class="right-huawei" :class="{'right-huawei-active':isActive}" @click="goHuaweiHome()"><img src="../assets/newImages/home/header1.png" alt=""><p>进入华为官网</p></div>
        </div>
        <!-- wap的tab -->
        <div class="logo-header" v-if="showWapNavIcon">
            <div class="logo">
                <img src="../assets/newImages/common/navWap/logo.png" alt="">
            </div>
            <div class="rightNav flexCenter" :class="pageScrollY>0?'position-fixed':'position-absolute'" @click="wapNavShow()">
                <img class="img1" v-if="wapShowNavtab== false" src="../assets/newImages/common/navWap/tabnav11.png" alt="">
                <img class="img2" v-if="wapShowNavtab" src="../assets/newImages/common/navWap/tabnav21.png" alt="">
            </div>
        </div>
        <!-- <div class="rightNav flexCenter" v-if="showWapNavIcon" :class="pageScrollY>0?'position-fixed':'position-absolute'" @click="wapNavShow()">
            <img class="img1" v-if="wapShowNavtab== false" src="../assets/newImages/common/navWap/tabnav1.png" alt="">
            <img class="img2" v-if="wapShowNavtab" src="../assets/newImages/common/navWap/tabnav2.png" alt="">
        </div> -->
        <div class="pop-bg" v-if="wapShowNavtab" @click.stop="wapNavShow()" @touchmove.prevent @mousewheel.prevent></div>
        <div class="navList" v-if="wapShowNavtab">
            <div class="nav-main">
                <div class="nav-line" @click="goPath('/home', '首页')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/home'==currentHash }"><p>首页</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavAgendaDesc" @click="goPath('/desc', '大会介绍')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/desc'==currentHash }"><p>大会介绍</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavAgendaList" @click="goPath('/agenda', '大会议程')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/agenda'==currentHash }"><p>大会议程</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavGuest" @click="goPath('/guest', '重磅嘉宾')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/guest'==currentHash }"><p>重磅嘉宾</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavHall" @click="goPath('/exhibition', '展厅导览')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/exhibition'==currentHash }"><p>展厅导览</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavNews" @click="goPath('/news', '热门资讯')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/news'==currentHash }"><p>热门资讯</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavPartner" @click="goPath('/partner', '生态伙伴')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/partner'==currentHash }"><p>生态伙伴</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavPic" @click="goPath('/wonderfulPic', '精彩图集')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/wonderfulPic'==currentHash }"><p>精彩图集</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavWords" @click="goPath('/wonderfulWords', '大咖观点')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/wonderfulWords'==currentHash }"><p>大咖观点</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavVideo"  @click="goPath('/video', '精彩视频')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/video'==currentHash }"><p>精彩视频</p><div class="line"></div></div>
                </div>
                <div class="nav-line" v-if="showNavDownload"  @click="goPath('/files', '资料中心')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/files'==currentHash }"><p>资料中心</p><div class="line"></div></div>
                </div>
                <div class="nav-line" @click="goPath('/guide', '参会指南')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/guide'==currentHash }"><p>参会指南</p><div class="line"></div></div>
                </div>
                <div v-if="userLogin" class="nav-line" @click="goPath('/my', '个人中心')">
                    <div class="nav-line-item-one" :class="{ 'nav-line-item-one-active': '/my'==currentHash }"><p>个人中心</p><div class="line"></div></div>
                </div>
                <div class="nav-line" @click="goHuaweiHome()">
                    <div class="nav-line-item-one"><p>进入华为官网</p><div class="fanhui"><img src="../assets/newImages/common/navWap/fanhui.png" alt=""></div></div>
                </div>
            </div>
        </div>
    </div>
</div>
    
</template>

<script>
    import config from '../config';
    import { getTime } from "@/utils/tool";
    // import maima from '@/utils/maima';
    export default {
        name: 'NavBar',
        data() {
            return {
                width:document.documentElement.clientWidth,
                // 导航栏
                navList: [
                    { content: "首页", type: 1, path:"/home"},
                    { content: "大会介绍", type: 1, path:"/desc"},
                    { content: "大会议程", type: 1, path:"/agenda" },
                    { content: "展厅导览", type: 1, path:"/guide" },
                    { content: "热门资讯", type: 1, path:"/news" },
                    { content: "生态伙伴", type: 1, path:"/partner"},
                    { content: "精彩视频", type: 1, path:"/video"},
                    { content: "大会地址", type: 1, path:"/exhibition"},
                ],
                showNavPc: false,
                currentHash: '',
                wapShowNavtab:false,
                pageScrollY: 1,
                isActive:false,
            }
        },
        computed:{
            showNavAgendaDesc(){
                return this.$store.state.showControl.showNavAgendaDesc;
            },
            showNavAgendaList(){
                return this.$store.state.showControl.showNavAgendaList;
            },
            showNavHall(){
                return this.$store.state.showControl.showNavHall;
            },
            showNavNews(){
                return this.$store.state.showControl.showNavNews;
            },
            showNavPartner(){
                return this.$store.state.showControl.showNavPartner;
            },
            showNavVideo(){
                return this.$store.state.showControl.showNavVideo;
            },
            showNavDownload(){
                return this.$store.state.showControl.showNavDownload;
            },
            showNavGuest(){
                return this.$store.state.showControl.showNavGuest;
            },
            showNavPic(){
                return this.$store.state.showControl.showNavPic;
            },
            showNavWords(){
                return this.$store.state.showControl.showNavWords;
            },
            userLogin(){
                return this.$store.state.userLogin;
            },
            allowScroll(){
                return this.$store.state.allowScroll;
            },
            showWapNavIcon(){
                if(this.width<767 && this.currentHash.indexOf('/privacy') == -1){
                    return true;
                }else{
                    return false;
                }
            }
        },
        watch: {
            '$route':'getPath'
        },
        // directives: {waves},
        props: {
            msg: String
        },
        methods: {
            goPath(path, name=''){
                if(this.width<767){
                    this.wapShowNavtab = false
                    this.$store.commit('setWapNavIsShow', false);
                }
                
                if(path == this.$route.path){
                    return;
                }else if(this.$route.query.hash && path == this.$route.query.hash){
                    return;
                }else{

                    // 埋码
                    this.$maima.index_top_menu_btn_click(name);

                    if(path == '/desc' 
                        // || path == '/guide'
                        || path == '/wonderfulPic'
                        || path == '/wonderfulWords'
                        // || path == '/exhibition'
                        ){
                        if(this.$route.path.indexOf('/home') != -1){
                            let id = path.replace('/', '#');
                            document.querySelector(id).scrollIntoView({
                                behavior: "smooth", // 平滑过渡
                                block: "center"
                            });
                        }else{
                            localStorage.setItem("eco_2021_index_hash", path);
                            this.$router.push({ 
                                path: '/',
                                // query: {
                                //     hash: path
                                // }
                            });
                        }
                    }else{
                        this.$router.push({ 
                            path: path 
                        });
                    }
                }

                
                return;
            },
            getPath(){
                if(this.$route.path == '/home' 
                    || this.$route.path == '/home/' 
                    || this.$route.path == '/privacy' 
                    || this.$route.path == '/privacy/'){
                    this.showNavPc = false;
                }else{
                    this.showNavPc = true;
                }
                this.currentHash = '/' + this.$route.path.split('/')[1];
                if(this.currentHash.indexOf('/exhibitionDetail') != -1){
                    this.currentHash = '/exhibition';
                }

                let currentTime = getTime();
                if(this.$store.state.liveStatus != 'middle' && currentTime > 1621209600 && currentTime < 1621353600){
                    this.$store.commit('setLiveStatus', 'middle');
                }
            },
            goHuaweiHome(){

                // 埋码
                this.$maima.index_officialweb_btn_click();
                window.open(config.url.home);
                return;
            },
            wapNavShow(){
                this.wapShowNavtab = !this.wapShowNavtab
                this.$store.commit('setWapNavIsShow', this.wapShowNavtab);
            },
            showText(){
                this.isActive=!this.isActive
            },
        },
        created(){
            let that = this;
            document.addEventListener('touchmove', function(){
                that.pageScrollY = window.scrollY;
            }, {passive: false});
        },
        mounted() {
            if(this.$route.path == '/home' 
                    || this.$route.path == '/home/' 
                    || this.$route.path == '/privacy' 
                    || this.$route.path == '/privacy/'){
                this.showNavPc = false;
            }else{
                this.showNavPc = true;
            }
            this.currentHash = '/' + this.$route.path.split('/')[1];
            if(this.currentHash.indexOf('/exhibitionDetail') != -1){
                this.currentHash = '/exhibition';
            }
        }
    }
</script>

<style scoped lang="scss">
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.pc{
    .nav-list {
        z-index: 999;
        position: fixed;
        top: 50%;
        left: pxToVw(95);
        transform: translateY(-50%);
        .nav-line {
            .nav-line-item {
                margin: 0;
                list-style: none;
                cursor: pointer;
                .nav-line-item-one{
                    position: relative;
                    width: pxToVw(105);
                    height: auto;
                    &:hover{
                        p{
                            font-size: pxToVw(24);
                            color: #C50819;
                            line-height: pxToVw(46);
                        }
                        .line{
                            display: block;
                        }
                    }
                    p{
                        font-size: pxToVw(19);
                        color: #666666;
                        line-height: pxToVw(46);
                    }
                    .line{
                        display: none;
                        position: absolute;
                        top: 50%;
                        left: pxToVw(-53);
                        width: pxToVw(41);
                        height: 1px;
                        background: #C50819;
                    }
                }
                .nav-line-item-one-active{
                    p{
                        font-size: pxToVw(24);
                        color: #C50819;
                        line-height: pxToVw(46);
                    }
                    .line{
                        display: block;
                    }
                }
                &:hover {
                    .nav-line-item-img {
                        background: #c30716;
                        border: none;
                    }
                }
            }
        }
    }
    .fixed-div{
        .logo{
            position: fixed;
            top: pxToVw(52);
            left: pxToVw(83);
            width: pxToVw(99);
            height: pxToVw(92);
            z-index: 999;
            img{
                width: pxToVw(99);
                height: pxToVw(92);
            }
        }
        .header-right{
            position: fixed;
            top: pxToVw(0);
            right: pxToVw(0);
            width: auto;
            height: pxToVw(67);
            display: flex;
            cursor: pointer;
            background: #C50819;
            border-radius: 1px;
            z-index: 999;
            .people{
                width: pxToVw(67);
                height: pxToVw(67);
                img{
                    width: 100%;
                    vertical-align: top;
                }
            }
            .right{
                width: pxToVw(67);
                height: pxToVw(67);
                background: #C50819;
                border-radius: 1px;
                position: relative;
                &:hover{
                    p{
                        display:block;
                    }
                }
                img{
                    width: pxToVw(24);
                    height: pxToVw(21);
                    vertical-align: top;
                }
                p{
                    display: none;
                    position: absolute;
                    right: 0;
                    top: 110%;
                    text-align: right;
                    width: pxToVw(144);
                    font-size: pxToVw(19);
                    color: #C50819;
                    line-height: pxToVw(23);
                }
            }
        }
        .header-right2{
            position: fixed;
            top: pxToVw(0);
            right: pxToVw(0);
            width: pxToVw(67);
            height: pxToVw(67);
            cursor: pointer;
            background: #C50819;
            border-radius: 1px;
            z-index: 999;
            &:hover{
                p{
                    display: block;
                }
            }
            img{
                width: pxToVw(24);
                height: pxToVw(21);
                vertical-align: top;
            }
            p{
                display: none;  
                position: absolute;
                right: 0;
                width: pxToVw(144);
                top: 110%;
                text-align: right;
                font-size: pxToVw(19);
                color: #C50819;
                line-height: pxToVw(23);
            }
        }
    }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .position-fixed{
        position: fixed;
    }
    .position-absolute{
        position: absolute;
    }
    .wap{
        display: block;
        .logo{
            z-index: 90;
            // position: fixed;
            // position: absolute;
            top: 1.6vw;
            left: 3.6vw;
            width: 6.9vw;
            height: 7.1vw;
            img{
                vertical-align: top;
                width: 6.9vw;
                height: 7.1vw;
            }
        }
        .header-right{
            display: flex;
            position: fixed;
            top: 0;
            right: 0;
            z-index: 99;
            .people{
                width: 10vw;
                height: 10vw;
                img{
                    width: 100%;
                }
            }
            .right-huawei{
                position: relative;
                width: 10vw;
                height: 10vw;
                background: #C50819;
                border-radius: 1px;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 3.6vw;
                    height: 3.1vw;
                }
                p{
                    display: none;
                    position: absolute;
                    right: 0;
                    top: 110%;
                    text-align: right;
                    width: 26vw;
                    font-size: 3.6vw;
                    color: #C50819;
                    line-height:4vw;
                    z-index: 2;
                }
            }
            .right-huawei-active{
                p{
                    display: block;
                    
                }
            }
            
        }
        
        .rightNav{
            // position: fixed;
            // position: absolute;
            top: 0;
            right: 0;
            z-index: 99;
            width: 10vw;
            height: 10vw;
            background: #C50819;
            border-radius: 1px;
            .img1{
                width: 4.3vw;
                height: 3.6vw;
            }
            .img2{
                width: 3.5vw;
                height: 3.3vw;
            }
        }
        .logo-header{
            position: fixed;
            top: 0;left: 0;
            width: 100vw;
            height: 9.7vw;
            padding: 0 0 0 3.6vw;
            display: flex;
            align-items: center;
            z-index: 99;
            justify-content: space-between;
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0 0 1.3vw 0 rgba(171,171,171,0.5);
            border-radius: 1px;
            .logo{
                width: 6.9vw;
                height: 7.1vw;
                img{
                    width: 100%;
                    vertical-align: top;
                }
            }
            .rightNav{
                width: 9.9vw;
                height: 9.7vw;
                background: none;
                border-radius: 0;
                .img1{
                    width: 4.3vw;
                    height: 3.6vw;
                }
                .img2{
                    width: 3.5vw;
                    height: 3.3vw;
                }
            }
        }
        .pop-bg{
            position: fixed;
            z-index: 92;
            top: 0;left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba($color: #000000, $alpha: 0.2);
        }
        .navList{
            position: fixed;
            top: 0;
            right: 0;
            z-index: 93;
            width: 54.7vw;
            height: 100vh;
            padding-top: 10vw;
            .nav-main{
                width: 100%;
                height: 100%;
                padding: 1.3vw 2.7vw 0 3.6vw;
                background: #FFFFFF;
                box-shadow: -0.4vw 0.4vw 1.3vw 0 rgba(165,165,165,0.5);
                overflow-y: scroll;
                scrollbar-width: none;
                -ms-overflow-style: none;
                &::-webkit-scrollbar{
                    width: pxToVw(0);
                }
                .nav-line{
                    width: 100%;
                    height: 13.3vw;
                    .nav-line-item-one{
                        position: relative;
                        width: 100%;
                        height: 13.3vw;
                        padding-left: 7.2vw;
                        border-bottom: 1px solid #DDDDDD;
                        p{
                            font-size: 3.7vw;
                            color: #333333;
                            line-height: 13.3vw;
                        }
                        .line{
                            display: none;
                            position: absolute;
                            top: 50%;
                            left: 0;
                            transform: translateY(-50%);
                            width: 0.8vw;
                            height: 5.1vw;
                            background: #C50819;
                        }
                        .fanhui{
                            position: absolute;
                            top: 50%;
                            right: 0;
                            transform: translateY(-50%);
                            width: 3.7vw;
                            height: 3.3vw;
                            img{
                                width: 3.7vw;
                                height: 3.3vw;
                            }
                        }
                    }
                    .nav-line-item-one-active{
                        p{color: #C50819;}
                        .line{display: block;}
                    }
                    
                }
            }
        }

    }
}
</style>
